import { render } from "./COIActionBarCancelDeliverySubmission.vue?vue&type=template&id=127d7ee4"
import script from "./COIActionBarCancelDeliverySubmission.vue?vue&type=script&lang=js"
export * from "./COIActionBarCancelDeliverySubmission.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__